import React, { useEffect, useState } from 'react'
import Questionnaire from '../../../../libs/api/services/Questionnaire'
const QuestionnaireBuilderContext = React.createContext()
export function QuestionnaireBuilderProvider({ assignmentId, children }) {
    const [ComponentValues, setComponentValues] = useState([])
    const [Components, setComponents] = useState([])
    const [ComponentAnswers, setComponentAnswers] = useState([])
    const [validated, setValidated] = useState(false)
    const [section, setSection] = useState(null)

    const GetComponentValues = (ComponentId, option, parentId) => {
        // console.log(ComponentValues, Object.keys(ComponentValues))
        if (Object.keys(ComponentValues).includes(ComponentId))
            return ComponentValues[ComponentId]
        return {}
    }

    const handleAdd = (Section, Subsection) => {
        Questionnaire
            .AddComponentToSection(Subsection ? Subsection : Section, {
                question: ''
            }).then((r) => {
                let _Components = Components
                _Components.push({ id: r.id, componentType: { type: 'New' } })
                setComponents([..._Components])
                ComponentValues[r.id] = {}
            }).catch((e) => { })
    }
    const handleClone = (Component) => {
        Questionnaire
            .CloneComponent(Component.id).then((r) => {
                let _Components = Components
                _Components.push(r)
                ComponentValues[r.id] = { ...ComponentValues[Component.id] }
                setComponents([..._Components])
            }).catch((e) => { })
    }
    const handleChange = (Component, Type) => {
        Questionnaire
            .SetComponentType(Component.id, {
                type: Type
            }).then((r) => {
                let _Components = Components
                let _cmp = _Components.find(a => a.id === Component.id)
                _cmp.componentType.type = Type
                setComponents([..._Components])
            }).catch((e) => { })
    }
    const handleRemove = (Component) => {
        Questionnaire
            .RemoveComponent(Component.id).then((r) => {
                let _Components = Components
                let _cmp = _Components.find(a => a.id === Component.id)

                _Components.splice(_Components.indexOf(_cmp), 1)
                setComponents([..._Components])
            }).catch((e) => { })
    }


    const SetQuestionnaireComponents = (components) => {
        setComponents(components)
        setComponentValues(components.reduce((acc, cur) => {
            let props = {}
            if (cur.properties)
                for (const prop in Object.entries(cur.properties))
                    props[cur.properties[prop].property] = cur.properties[prop].values
            return { ...acc, [cur.id]: props }
        }, {}))
    }
    const SetAnswers = (answers) => {
        let answer = {}
        for (let i = 0; i < answers.length; i++)
            answer[answers[i].answerType.id] = answers[i].answer
        setComponentAnswers(prev => ({ ...prev, ...answer }))
    }
    const SetComponentValue = async (Component, prop, value) =>
        Questionnaire
            .SetComponentProperty(Component.id, {
                property: prop,
                values: value,
                component: {
                    id: Component.id
                }
            }).then(() => {
                var items = ComponentValues
                if (!Object.keys(items).includes(Component.id)) items[Component.id] = {}
                items[Component.id][prop] = value
                setComponentValues({ ...items })
            })

    useEffect(() => {
        // section
        console.log('SetComponentAnswers', ComponentAnswers, Components, section)
        let valid = true
        let filterComponents = section != null ? Components.filter(a => section.includes(a.id)) : Components
        for (const i in filterComponents) {
            const required = filterComponents[i].properties && filterComponents[i].properties.find(prop => prop.property === "Required")
            if (required && JSON.parse(required.values)) {
                if (
                    typeof ComponentAnswers[filterComponents[i].id] === 'undefined' ||
                    (ComponentAnswers[filterComponents[i].id] === "")) {
                    valid = false
                }
            }
        }
        setValidated(valid)
    }, [ComponentAnswers, Components, section])

    const SetResponse = async (component, value, update) => {

        // var _formData = state.formData
        // Find component types for dynamic sub sections
        try {
            // Find component types for dynamic sub sections
            // try {
            //     const _subSection = _findComponentOptionProperty(componentId, value, 'subsection')

            //     if (_subSection !== 'Arr') {
            //         if (_subSection)
            //             _toggleActiveSection(componentId, _subSection)
            //         else
            //             _toggleActiveSection(componentId, undefined)
            //     }
            // } catch (e) { }

            // try {
            //     var el = _formData.find(c => c.componentId === componentId)
            //     el.value = value
            //     if (value && value !== "") {
            //         el.valid = true
            //     } else {
            //         el.valid = false
            //     }
            // } catch (e) { }
            if (update)
                Questionnaire
                    .QuestionnaireResponse(assignmentId, {
                        answerType: {
                            id: component.id
                        },
                        answer: value
                    })
                    .then((r) => {
                        let _ComponentAnswers = ComponentAnswers
                        _ComponentAnswers[component.id] = value
                        setComponentAnswers({ ..._ComponentAnswers })
                    })
            // else
            //     SetAnswers(ComponentAnswers)
        } catch (e) {
            console.error(e)

        }
    }

    return (
        <QuestionnaireBuilderContext.Provider value={{
            SetComponentValue,
            ComponentValues, // TODO : Romve this to GetComponentValues
            SetQuestionnaireComponents,
            Components,
            SetResponse,
            SetAnswers,
            ComponentAnswers,
            handleAdd,
            handleChange,
            handleClone,
            handleRemove,
            validated,
            setSection,
            GetComponentValues
        }}>
            {children}
        </QuestionnaireBuilderContext.Provider>
    )
}

export default QuestionnaireBuilderContext